import { Time } from "./time";
import { Validateable } from "./interfaces/validateable";
import { StellarSendType } from "@helpers/types";

export class ContactField extends Validateable {
	private deleted: boolean = false;
	private editable: boolean = true;
	private type: string = "";
	private last_used: Time = new Time();
	public cryptocoin_id: string = "";

	public name: string = "";
	public value: string = "";
	public destination_tag: string = "";
	public dt_type: StellarSendType = "memo_id";
	public coin_network_id = "";

	public getDestinationTag(): string {
		return this.destination_tag;
	}

	public setDestinationTag(destinationTag: string): void {
		this.destination_tag = destinationTag;
	}

	public constructor(type: string = "btc_address", cryptocoin_id: string = "1") {
		super();
		this.type = type;
		this.cryptocoin_id = cryptocoin_id;
	}

	public getValue(): string {
		return this.value;
	}

	public getType(): string {
		return this.type;
	}

	public setType(type: string): void {
		this.type = type;
	}

	public get _type(): string {
		return this.type;
	}

	public set _type(type: string) {
		this.setType(type);
	}

	public get _cryptocoin_id(): string {
		return this.cryptocoin_id;
	}

	public set _cryptocoin_id(id: string) {
		this.cryptocoin_id = id;
	}

	public get _coin_network_id(): string {
		return this.coin_network_id;
	}

	public set _coin_network_id(id: string) {
		this.coin_network_id = id;
	}

	public get _dt_type(): StellarSendType {
		return this.dt_type;
	}

	public set _dt_type(type: StellarSendType) {
		this.dt_type = type;
	}

	public isDeleted(): boolean {
		return this.deleted;
	}

	public isEditable(): boolean {
		return this.editable;
	}

	public lastUsed(): number {
		return this.last_used.getUnix();
	}

	public getLastUsedTime(): Time {
		return this.last_used;
	}

	public getLastUsedDate(): Date {
		return this.last_used.date();
	}

	public setLastUsed(t: Time): void {
		this.last_used = t;
	}

	public getDeleted(): boolean {
		return this.deleted;
	}

	public setValue(recipient: string): void {
		this.value = recipient;
	}

	public getSymbol(): string {
		if (!this.type) {
			return "";
		}
		const separator = this.type.indexOf("_");
		return separator >= 0 ? this.type.substring(0, separator).toUpperCase() : this.type.toUpperCase();
	}

	public tryName(): string {
		return this.name === "" ? this.value : this.name;
	}

	public getName(): string {
		return this.name;
	}

	public setName(s: string): void {
		this.name = s;
	}

	public getCryptocoinId(): string {
		return this.cryptocoin_id;
	}
}
